var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "33px",
    viewBox: "0 0 36 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9833DD38-94C6-48FE-8D07-62138DFF2DBC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.6564278,30.4342766 L10.7530324,30.521406 L-1.5187851e-13,33 L3.31974502,24.0734923 C1.84520541,21.7035729 1,18.9446845 1,16 C1,7.163444 8.61115925,3.55271368e-15 18,3.55271368e-15 C27.3888407,3.55271368e-15 35,7.163444 35,16 C35,24.836556 27.3888407,32 18,32 C15.3698968,32 12.8792941,31.4378613 10.6564278,30.4342766 Z M10,19 C11.1045695,19 12,18.1045695 12,17 C12,15.8954305 11.1045695,15 10,15 C8.8954305,15 8,15.8954305 8,17 C8,18.1045695 8.8954305,19 10,19 Z M18,19 C19.1045695,19 20,18.1045695 20,17 C20,15.8954305 19.1045695,15 18,15 C16.8954305,15 16,15.8954305 16,17 C16,18.1045695 16.8954305,19 18,19 Z M25,19 C26.1045695,19 27,18.1045695 27,17 C27,15.8954305 26.1045695,15 25,15 C23.8954305,15 23,15.8954305 23,17 C23,18.1045695 23.8954305,19 25,19 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5.-Profile-&-Settings-\\uD83D\\uDC81\\uD83C\\uDFFB\\u200D\\u2640\\uFE0F",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User-Profile",
    transform: "translate(-131.000000, -1523.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-1.000000, 1502.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/General/Profile-Message",
    transform: "translate(128.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(4.500000, 6.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Colors/Maroon",
    mask: "url(#mask-2)",
    fill: "#710D0D"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.500000, -6.000000)",
    id: "Base"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 44,
    height: 44
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/message-icon.f712d1a6c8bc42c84a95ab50147f4718.svg";
export { ForwardRef as ReactComponent };